// Angular
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
// PrimeNG
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SidebarModule } from 'primeng/sidebar';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
// Services
import { PaymentMethodService } from '@core/services-v2/payment-method.service';
// Models
import { IKhipuBank } from '@core/models-v2/payment-method/khipu-bank.interface';

const NG_MODULES = [CommonModule, FormsModule, ReactiveFormsModule];
const PRIME_MODULES = [
  TableModule,
  ButtonModule,
  RadioButtonModule,
  ProgressSpinnerModule,
  SidebarModule,
  ToastModule,
];

@Component({
  selector: 'app-khipu-sidebar',
  standalone: true,
  imports: [NG_MODULES, PRIME_MODULES],
  templateUrl: './khipu-sidebar.component.html',
  styleUrl: './khipu-sidebar.component.scss',
  providers: [MessageService],
})
export class KhipuSidebarComponent {
  //#region Inputs & Outputs
  @Input() visibleSidebar: boolean = false;
  @Output() onHideSidebar = new EventEmitter<void>();
  @Output() onBankSelected = new EventEmitter<IKhipuBank>();
  @Output() visibleSidebarChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  //#endregion

  bancoForm: FormGroup;
  listaBancos: IKhipuBank[] = [];
  banco?: IKhipuBank;
  index_banco = -1;
  selectbank: boolean = false;
  loadbank: boolean = false;
  isLoading: boolean = false;
  selectedBankId: string | null = null;

  //#region Getters
  get idField() {
    return this.bancoForm.get('id');
  }
  //#endregion

  //#region Dependencies
  private readonly messageService = inject(MessageService);
  //#endregion

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private readonly paymentMethodService: PaymentMethodService
  ) {
    this.bancoForm = this.fb.group({
      id: new FormControl(null),
    });
  }

  ngOnInit(): void {
    this.loadbank = true;
    this.paymentMethodService.getKhipuBanks().subscribe({
      next: (banks) => {
        this.listaBancos = banks;
        this.convertir_numero();
        this.loadbank = false;
      },
      error: (err) => {
        console.log(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudieron listar los bancos de Khipu',
        });
        this.loadbank = false;
      },
    });
  }

  ngOnChange() {
    this.loadbank = false;
  }

  close() {
    this.paymentMethodService.close(true);
  }
  hide() {
    this.visibleSidebar = false;
    //esto es temporal, hay que fixearlo
    this.onHideSidebar.emit();
    this.visibleSidebarChange.emit(this.visibleSidebar);
  }
  show() {
    this.visibleSidebar = true;
    this.visibleSidebarChange.emit(this.visibleSidebar);
  }
  convertir_numero() {
    this.listaBancos.map((item: any) => {
      item.min_amount = Number(item.min_amount);
    });
  }
  Selecciona_Banco(banco: any, index: any) {
    this.selectedBankId = banco.bankId;
    this.index_banco = index;
    this.selectbank = true;
    this.banco = banco;
    this.onBankSelected.emit(banco);
  }

  async Pagar() {
    this.loadbank = true;
    this.paymentMethodService.selectBancoKhipu(this.banco);
    await new Promise((resolve) => {
      setTimeout(() => {
        resolve('listo');
      }, 5000);
    });
    this.loadbank = false;
    //this.paymentMethodService.close(true);
    this.onBankSelected.emit(this.banco);
  }
  listadoBancos() {
    this.isLoading = true;
    setTimeout(() => {
      this.listaBancos, this.cdr.detectChanges();
      1000;
    });
  }
}
